import { z } from 'zod';

export const askUserToolOptionSchema = z.object({
  label: z.string().trim().min(1, {
    error: 'Le libelle de l option ask_user est requis.',
  }),
  value: z.string().trim().min(1, {
    error: 'La valeur de l option ask_user est requise.',
  }),
});

export const askUserToolInputSchema = z.object({
  allowFreeText: z.boolean().optional(),
  allowMultiple: z.boolean().optional(),
  options: z.array(askUserToolOptionSchema).min(2, {
    error: 'Le widget ask_user doit proposer au moins 2 options.',
  }).max(6, {
    error: 'Le widget ask_user doit proposer au maximum 6 options.',
  }),
  question: z.string().trim().min(1, {
    error: 'La question ask_user est requise.',
  }),
});

export const askUserToolOutputSourceSchema = z.enum(['answered_in_text', 'widget'], {
  error: 'La source de reponse ask_user est invalide.',
});

export const askUserToolOutputSchema = z.object({
  labels: z.array(z.string()).optional(),
  source: askUserToolOutputSourceSchema,
  text: z.string().optional(),
  values: z.array(z.string()),
});

export type AskUserToolOptionDTO = z.infer<typeof askUserToolOptionSchema>;
export type AskUserToolInputDTO = z.infer<typeof askUserToolInputSchema>;
export type AskUserToolOutputSourceDTO = z.infer<typeof askUserToolOutputSourceSchema>;
export type AskUserToolOutputDTO = z.infer<typeof askUserToolOutputSchema>;
